<div
  [ngClass]="{ 'standalone-mode modal-content': isStandaloneMode }"
  class="organization-modal"
  [attr.piqetAngularDraggable]="!isStandaloneMode ? '' : null"
>
  <div class="modal-header" *ngIf="!isStandaloneMode">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
        {{ modalLabel }}
      </div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" alt="Close button" />
    </button>
  </div>

  <div class="modal-body">
    <div class="bootstrap-dialog-body">
      <div>
        <form [formGroup]="commentForm">
          <div disabledStyle="blur" class="form-group">
            <label *ngIf="commentForm.controls['comment']?.value" class="sub-header-drpdown pb-2"
              >Reason should be only 500 characters.</label
            >
            <div class="services-form">
              <textarea
                formControlName="comment"
                class="resizable-textarea"
                cols="20"
                id="Description"
                name="Description"
                rows="4"
                maxlength="500"
                placeholder="Comment"
              ></textarea>
              <label *ngIf="!commentForm.controls['comment']?.value">Reason</label>
            </div>
            <div
              *ngIf="
                commentForm.controls['comment']?.touched && commentForm.controls['comment']?.invalid
              "
            >
              <div
                class="input-error"
                *ngIf="commentForm.controls['comment']?.errors?.['required']"
              >
                Reason is required.
              </div>
              <div
                class="input-error"
                *ngIf="commentForm.controls['comment']?.errors?.['maxlength']"
              >
                Reason cannot exceed
                {{ commentForm.controls['comment'].errors?.['maxlength']?.requiredLength }}
                characters.
              </div>
            </div>
          </div>
          <div class="info-note mt-2 text-sm text-gray-600 flex items-center">
            <div class="alert alert-warning mt-3" role="alert">
              <strong>Note:</strong> Your added reason will be sent to the user via email.
            </div>
          </div>
        </form>

        <div class="setButtonAndError box-footer">
          <div class="modal-footer">
            <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
            <button
              type="button"
              class="modelBtn purpleBtnHoverEffect"
              (click)="onSave()"
              [disabled]="submitted && commentForm.invalid"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
